module.exports = __webpack_public_path__ + "img/CSS.f92a3730.png";